// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const utr: CountryValidator<"GB"> = createValidator(
  "gb.utr",
  82,
);

export default utr;
export const compact = utr.compact;
export const format = utr.format;
export const validate = utr.validate;
export const generate = (): string =>
  utr.generate?.() ??
  (() => {
    throw new Error(
      "Validator gb.utr cannot generate values",
    );
  })();
